const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ProductDetailServiceQuery: any = {
    GetStoreCity: Backofficebff + '/v1/omnichannel/getstorecity',
    GetStoreCounty: Backofficebff + '/v1/omnichannel/getstorecounty',
    GetStoreStock: Backofficebff + '/v1/omnichannel/getstorestock',
    GetComponentInformationBySpecialCode: Backofficebff + '/v1/Pim/GetComponentInformationBySpecialCode',
    GetStyleMeasurementByPlmCode: Backofficebff + '/v1/Pim/GetStyleMeasurementByPlmCode',
};
